module.exports = __webpack_public_path__ + "static/media/brand-refresh-plus.f33350ea.svg";